import { render, staticRenderFns } from "./Graficos.vue?vue&type=template&id=f351dcd0&scoped=true"
import script from "./Graficos.vue?vue&type=script&lang=js"
export * from "./Graficos.vue?vue&type=script&lang=js"
import style0 from "./Graficos.vue?vue&type=style&index=0&id=f351dcd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f351dcd0",
  null
  
)

export default component.exports